import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceDetailHero from '../components/ServiceDetailHero';
import ServiceDetailContent from '../components/ServiceDetailContent';
import ServiceDetailFeatures from '../components/ServiceDetailFeatures';
import ServiceDetailProcess from '../components/ServiceDetailProcess';
import ServiceDetailPricing from '../components/ServiceDetailPricing';
import CTASection from '../../home/components/CTASection';
import { useSEO } from '../../../utils/seo';

const CRMAutomationPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'CRM & Otomasyon - Sigorta360 | WhatsApp Entegrasyonu ve Müşteri Yönetimi',
    description: 'Sigorta acenteleri için CRM sistemi kurulumu ve otomasyon çözümleri. WhatsApp Business API, poliçe takip sistemi, otomatik hatırlatmalar. 12.000₺\'den başlayan paketler.',
    keywords: 'sigorta CRM, CRM otomasyon, WhatsApp entegrasyonu, poliçe takip sistemi, müşteri yönetimi',
    canonical: `${siteUrl}/hizmetler/crm-otomasyon`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'CRM & Otomasyon Çözümleri',
      description: 'Sigorta acenteleri için CRM sistemi kurulumu ve süreç otomasyonu hizmeti',
      provider: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      },
      areaServed: {
        '@type': 'Country',
        name: 'Türkiye'
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TRY',
        lowPrice: '12000',
        highPrice: '28000',
        offerCount: '3'
      }
    }
  });

  const heroData = {
    category: 'Teknoloji & Otomasyon',
    title: 'CRM & Otomasyon Çözümleri',
    description: 'Poliçe formlarından WhatsApp entegrasyonuna kadar tüm süreçlerinizi otomatikleştiriyoruz. Müşteri ilişkilerinizi yönetin, zamandan tasarruf edin, satışlarınızı artırın.',
    image: 'https://public.readdy.ai/ai/img_res/c60914f9f2335243384adea3ed46ad24.jpg',
  };

  const contentData = {
    overview: 'CRM ve otomasyon sistemleri, sigorta acentelerinin verimliliğini artıran, müşteri memnuniyetini yükselten ve satış süreçlerini hızlandıran teknolojilerdir. Sigorta360 olarak, size özel CRM çözümleri geliştiriyor ve tüm süreçlerinizi otomatikleştiriyoruz.',
    benefits: [
      {
        icon: 'ri-time-line',
        title: 'Zaman Tasarrufu',
        description: 'Manuel işlemleri otomatikleştirerek günde 3-4 saat kazanın, asıl işinize odaklanın.',
      },
      {
        icon: 'ri-user-follow-line',
        title: 'Müşteri Takibi',
        description: 'Tüm müşteri bilgilerini tek yerden yönetin, hiçbir fırsatı kaçırmayın.',
      },
      {
        icon: 'ri-notification-line',
        title: 'Otomatik Hatırlatmalar',
        description: 'Poliçe yenileme, doğum günü ve özel günlerde otomatik bildirimler gönderin.',
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Satış Artışı',
        description: 'Organize süreçler ve takip sistemi ile satışlarınızı %40\'a kadar artırın.',
      },
    ],
  };

  const featuresData = {
    title: 'CRM & Otomasyon Hizmetlerimiz',
    features: [
      {
        icon: 'ri-database-2-line',
        title: 'CRM Sistemi Kurulumu',
        description: 'Size özel CRM sistemi seçimi ve kurulumu, müşteri veritabanı oluşturma, veri aktarımı.',
      },
      {
        icon: 'ri-whatsapp-line',
        title: 'WhatsApp Business API',
        description: 'WhatsApp Business API entegrasyonu, otomatik mesajlaşma, toplu mesaj gönderimi, chatbot kurulumu.',
      },
      {
        icon: 'ri-file-list-3-line',
        title: 'Form Entegrasyonu',
        description: 'Web sitesi formlarının CRM\'e otomatik aktarımı, lead yönetimi, otomatik e-posta bildirimleri.',
      },
      {
        icon: 'ri-calendar-check-line',
        title: 'Poliçe Takip Sistemi',
        description: 'Poliçe yenileme takibi, otomatik hatırlatmalar, müşteri segmentasyonu.',
      },
      {
        icon: 'ri-mail-send-line',
        title: 'E-posta Otomasyonu',
        description: 'Otomatik e-posta kampanyaları, kişiselleştirilmiş mesajlar, drip kampanyalar.',
      },
      {
        icon: 'ri-bar-chart-box-line',
        title: 'Raporlama & Analiz',
        description: 'Satış raporları, müşteri analizi, performans takibi, özel dashboard\'lar.',
      },
    ],
  };

  const processData = {
    title: 'CRM Kurulum Sürecimiz',
    steps: [
      {
        number: '01',
        title: 'İhtiyaç Analizi',
        description: 'Mevcut süreçlerinizi inceleme, ihtiyaçlarınızı belirleme, CRM sistemi seçimi.',
      },
      {
        number: '02',
        title: 'Sistem Kurulumu',
        description: 'CRM kurulumu, veritabanı yapılandırması, kullanıcı hesapları oluşturma.',
      },
      {
        number: '03',
        title: 'Entegrasyonlar',
        description: 'Web sitesi, WhatsApp, e-posta ve diğer sistemlerle entegrasyon.',
      },
      {
        number: '04',
        title: 'Otomasyon Kurulumu',
        description: 'İş akışları oluşturma, otomatik bildirimler, hatırlatma sistemleri.',
      },
      {
        number: '05',
        title: 'Eğitim & Destek',
        description: 'Ekip eğitimi, kullanım kılavuzu, sürekli teknik destek.',
      },
    ],
  };

  const pricingData = {
    title: 'CRM & Otomasyon Paketleri',
    packages: [
      {
        name: 'Başlangıç',
        price: '12.000',
        period: 'kurulum',
        description: 'Temel CRM kurulum ve otomasyon',
        features: [
          'CRM sistemi kurulumu',
          'Basit otomasyon akışları',
          'Müşteri kayıt ve pipeline kullanımı',
          'Temel müşteri takip sistemi',
          'Form entegrasyonu',
          'E-posta bildirimleri',
          '3 Kullanıcı lisansı',
          '3 Ay teknik destek',
        ],
        highlighted: false,
      },
      {
        name: 'Profesyonel',
        price: '18.000',
        period: 'kurulum',
        description: 'Segmentasyon ve otomatik akışlar',
        features: [
          'Gelişmiş CRM kurulumu',
          'Müşteri segmentasyonu',
          'Otomatik teklif sistemleri',
          'Mail ve SMS otomasyon akışları',
          'Poliçe takip ve hatırlatma sistemi',
          'Gelişmiş raporlama',
          '10 Kullanıcı lisansı',
          '6 Ay teknik destek',
        ],
        highlighted: true,
      },
      {
        name: 'Premium',
        price: '28.000',
        period: 'kurulum',
        description: 'Çoklu entegrasyon ve AI destekli süreçler',
        features: [
          'Premium CRM kurulumu',
          'ERP, web ve e-ticaret tam entegrasyonu',
          'AI destekli süreç otomasyonları',
          'Çoklu platform entegrasyonları',
          'Gelişmiş analitik ve tahminleme',
          'Özel iş akışları ve senaryolar',
          'Sınırsız kullanıcı',
          '12 Ay premium destek',
        ],
        highlighted: false,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServiceDetailHero data={heroData} />
        <ServiceDetailContent data={contentData} />
        <ServiceDetailFeatures data={featuresData} />
        <ServiceDetailProcess data={processData} />
        <ServiceDetailPricing data={pricingData} />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default CRMAutomationPage;
